import { render, staticRenderFns } from "./Grafik.vue?vue&type=template&id=2ceba7fc"
import script from "./Grafik.vue?vue&type=script&lang=js"
export * from "./Grafik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports